import React, { useState, useEffect } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Breadcrumbs from '../common/components/Breadcrumbs';
import TransactionsSearch from './search/TransactionsSearch';
import TransactionsTable from './table/TransactionsTable';
import { useQueryString, setQueryString } from '../common/helpers/queryString';
import { searchTransactions } from './TransactionsActions';
import { PrepareUrl } from '../common/helpers/PrepareUrl';
import RouterPaths from '../constants/RouterPaths';

let breadcrumbsItems = [];

const TransactionsPage = ({ history, location }) => {
  const { dealerId } = useParams();
  const query = useQueryString();
  const dispatch = useDispatch();

  if (dealerId) {
    breadcrumbsItems = [
      { id: 1, type: 'home' },
      { id: 2, type: 'link', text: 'Dealers', url: RouterPaths.DEALERS },
      {
        id: 3,
        type: 'link',
        text: 'Edit Dealer',
        url: PrepareUrl(RouterPaths.DEALER_INFORMATION, { id: dealerId }),
      },
      { id: 4, type: 'span', text: 'Transactions' },
    ];
  } else {
    breadcrumbsItems = [
      { id: 1, type: 'home' },
      { id: 2, type: 'span', text: 'Transactions' },
    ];
  }

  const items = useSelector(state => state.transactions.get('items'));
  const totalItems = useSelector(state => state.transactions.get('totalItems'));
  const [searchParams, setSearchParams] = useState({
    offset: query.get('page') ? +query.get('page') - 1 : 0,
    dealerId: dealerId || null,
  });

  useEffect(() => {
    setSearchParams(prevState => ({
      ...prevState,
      dealerId: dealerId || null,
    }));
  }, [dispatch, dealerId]);

  useEffect(() => {
    dispatch(searchTransactions(searchParams));
  }, [dispatch, searchParams]);

  const handleSearch = (values, { setSubmitting }) => {
    setSearchParams(prevState => ({ ...prevState, ...values, offset: 0 }));
    setSubmitting(false);
  };

  const changeOffset = value => {
    setSearchParams(prevState => ({
      ...prevState,
      offset: value,
    }));
    history.push(setQueryString(location, 'page', value + 1));
  };

  return (
    <div className="content">
      <Breadcrumbs items={breadcrumbsItems} />
      <TransactionsSearch handleSearch={handleSearch} />
      <TransactionsTable
        data={{ items, total: totalItems }}
        offset={searchParams.offset}
        changeOffset={changeOffset}
      />
    </div>
  );
};

export default withRouter(TransactionsPage);
